"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSubtractDateTime = exports.createAddDateTime = exports.dateSubtract = exports.dateAdd = exports.zoneName = exports.year = exports.weeksInWeekYear = exports.weekdayShort = exports.weekdayLong = exports.weekday = exports.weekYear = exports.weekNumber = exports.second = exports.quarter = exports.offset = exports.monthShort = exports.monthLong = exports.month = exports.minute = exports.millisecond = exports.hour = exports.daysInYear = exports.daysInMonth = exports.day = exports.now = exports.createDuration = exports.createDateTime = void 0;
var luxon_1 = require("luxon");
var mathjs_1 = require("mathjs");
var dateTimeGetterFactory = function (key) {
    return mathjs_1.factory(key, [], function () { return function (date) { return luxon_1.DateTime.fromISO(date)[key]; }; });
};
exports.createDateTime = mathjs_1.factory('DateTime', ['typed'], function (_a) {
    var typed = _a.typed;
    typed.addType({
        name: 'DateTime',
        test: function (value) { return luxon_1.DateTime.fromISO(value).isValid; }
    });
    return function (value) { return luxon_1.DateTime.fromISO(value); };
});
exports.createDuration = mathjs_1.factory('Duration', ['typed'], function (_a) {
    var typed = _a.typed;
    typed.addType({
        name: 'Duration',
        test: function (value) { return luxon_1.Duration.fromISO(value).isValid; }
    });
    return function (value) { return luxon_1.Duration.fromISO(value); };
});
exports.now = mathjs_1.factory('now', [], function () { return function () { return luxon_1.DateTime.local(); }; });
exports.day = dateTimeGetterFactory('day');
exports.daysInMonth = dateTimeGetterFactory('daysInMonth');
exports.daysInYear = dateTimeGetterFactory('daysInYear');
exports.hour = dateTimeGetterFactory('hour');
exports.millisecond = dateTimeGetterFactory('millisecond');
exports.minute = dateTimeGetterFactory('minute');
exports.month = dateTimeGetterFactory('month');
exports.monthLong = dateTimeGetterFactory('monthLong');
exports.monthShort = dateTimeGetterFactory('monthShort');
exports.offset = dateTimeGetterFactory('offset');
exports.quarter = dateTimeGetterFactory('quarter');
exports.second = dateTimeGetterFactory('second');
exports.weekNumber = dateTimeGetterFactory('weekNumber');
exports.weekYear = dateTimeGetterFactory('weekYear');
exports.weekday = dateTimeGetterFactory('weekday');
exports.weekdayLong = dateTimeGetterFactory('weekdayLong');
exports.weekdayShort = dateTimeGetterFactory('weekdayShort');
exports.weeksInWeekYear = dateTimeGetterFactory('weeksInWeekYear');
exports.year = dateTimeGetterFactory('year');
exports.zoneName = dateTimeGetterFactory('zoneName');
exports.dateAdd = mathjs_1.factory('dateAdd', [], function () { return function (date, duration) {
    return luxon_1.DateTime.fromISO(date).plus(luxon_1.Duration.fromISO(duration));
}; });
exports.dateSubtract = mathjs_1.factory('dateSubtract', [], function () { return function (date, duration) {
    return luxon_1.DateTime.fromISO(date).minus(luxon_1.Duration.fromISO(duration));
}; });
exports.createAddDateTime = mathjs_1.factory('add', ['typed', 'DateTime', 'Duration'], function (_a) {
    var typed = _a.typed;
    return typed('add', {
        'DateTime, Duration': function (date, duration) {
            return date.plus(duration);
        }
    });
});
exports.createSubtractDateTime = mathjs_1.factory('subtract', ['typed', 'DateTime', 'Duration'], function (_a) {
    var typed = _a.typed;
    return typed('subtract', {
        'DateTime, Duration': function (date, duration) {
            return date.minus(duration);
        }
    });
});
//# sourceMappingURL=date.js.map